/// <amd-module name="SuiteCommerce.FeaturedCategory.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.View", ["require", "exports", "jQuery", "CustomContentType.Base.View", "Backbone.CollectionView", "SuiteCommerce.FeaturedCategory.Model", "SuiteCommerce.FeaturedCategory.Button.View", "SuiteCommerce.FeaturedCategory.Button.Model", "sc_featuredcategory_cct.tpl",  "Code25.CaterpartsGlobal.Related.View"], function (require, exports, jQuery, CustomContentTypeBaseView, BackboneCollectionView, FeaturedCategory_Model_1, FeaturedCategory_Button_View_1, FeaturedCategory_Button_Model_1, featuredCategoryTemplate, RelatedView) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var featuredIndex=0;
    var FeaturedCategoryView = /** @class */ (function (_super) {
        __extends(FeaturedCategoryView, _super);
        function FeaturedCategoryView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = featuredCategoryTemplate;
            _this.container = options.container;
            _this.buttonView = new FeaturedCategory_Button_View_1.ButtonView({ model: new FeaturedCategory_Button_Model_1.ButtonModel() });
            _this.model = new FeaturedCategory_Model_1.FeaturedCategoryModel({ container: _this.container });
            _this.setupListeners();
            featuredIndex++;
            _this.featuredIndex=featuredIndex;
            return _this;
        }
        FeaturedCategoryView.prototype.setupListeners = function () {
            var _this = this;
            this.model.on('reset sync add remove change destroy', function () {
                _this.updateCategoryButtonSettings();
                _this.render();
            });
            // this.model.items.on('reset sync add remove change destroy', function () { return _this.render(); });
        };
        FeaturedCategoryView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.parseSettings(settings);
            this.fetchFeaturedCategoryData();
            return jQuery.Deferred().resolve();
        };
        FeaturedCategoryView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.parseSettings(settings);
            
            this.fetchFeaturedCategoryData();
            return jQuery.Deferred().resolve();
        };
        FeaturedCategoryView.prototype.parseSettings = function (settings) {
            this.model.addProperties(settings);
        };
        FeaturedCategoryView.prototype.fetchFeaturedCategoryData = function () {
            if (this.model.categoryId) {
                
                this.fetchFeaturedCategoryModel();
            }
        };
        
        FeaturedCategoryView.prototype.fetchFeaturedCategoryModel = function () {
            if (this.model.buttonText) {

                this.model.fetch().done(function () {

                });
            }
        };
        FeaturedCategoryView.prototype.updateCategoryButtonSettings = function () {
            this.buttonView.model.updateButtonSettings({
                buttonText: this.model.buttonText,
                customUrl: this.model.customUrl,
                fullurl: this.model.fullUrl,
                buttonStyle: this.model.buttonStyle
            });
        };
        FeaturedCategoryView.prototype.validateContextDataRequest = function () {
            return true;
        };
        FeaturedCategoryView.prototype.logGoToCategory = function () {

        };
        
        Object.defineProperty(FeaturedCategoryView.prototype, "childViews", {
            get: function () {
                var _this = this;
                
                return {
                    'FeaturedCategory.Button.View': function () {
                        return _this.buttonView;
                    }
                    , 'Related': function () {
                        try {
                            if(_this.model){
                                
                            return new RelatedView({ application: SC.Application, category:true,categoryUrl:_this.model.get("custrecord_cct_ns_featcatcct_customurl") ,featuredIndex:_this.featuredIndex});
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        FeaturedCategoryView.prototype.getContext = function () {
            if (!this.model.customUrl) {
                this.model.customUrl = this.model.fullUrl;
            }
            return {
                customUrl: this.model.customUrl,
                hasHeader: this.model.hasHeader,
                headerAllowLink: this.model.headerAllowLink,
                headerIsHtml: this.model.headerIsHtml,
                headerPosition: this.model.headerPosition,
                headerText: this.model.headerText,
                featuredIndex:this.featuredIndex
            };
        };
        return FeaturedCategoryView;
    }(CustomContentTypeBaseView));
    exports.FeaturedCategoryView = FeaturedCategoryView;
});
